
export { default as Home }                          from './home';
export { default as SimpleTables  }                 from './simpleTables';
export { default as BasicElements }                 from './basicElements';
export { default as General }                       from './general';
export { default as Modals }                        from './modals/Modals';
export { default as PageNotFound }                  from './pageNotFound';
export { default as StatsCard }                     from './statsCard';
export { default as EarningGraph }                  from './earningGraph';
export { default as Notifications }                 from './notifications';
export { default as WorkProgress }                  from './workProgress';
export { default as TwitterFeed }                   from './twitterFeed';
export { default as TeamMatesView }                 from './teamMates';
export { default as TodoListView }                  from './todoList';
export { default as Breadcrumb }                    from './breadcrumb';
export { default as Stat }                          from './stat';
export { default as BasicProgressBar }              from './basicProgressBar';
export { default as TabPanel }                      from './tabPanel';
export { default as StripedProgressBar }            from './stripedProgressBar';
export { default as AlertView   }                   from './alert';
export { default as PaginationView }                from './pagination';

export { default as PartnerDashboard }              from './partner/partnerDashboard';
export { default as PartnerBBFS }                   from './partner/partnerBBFS';
export { default as PartnerFootball }               from './partner/partnerFootball';
export { default as PartnerPlay }                   from './partner/partnerPlay';
export { default as PartnerBadminton }              from './partner/partnerBadminton';
export { default as PartnerRental }                 from './partner/partnerRental';
export { default as PartnerTournament }             from './partner/partnerTournament';
export { default as PartnerSummerBadminton }             from './partner/partnerSummerBadminton';

export { default as CreateFixture }                 from './partner/crud/createFixture';
export { default as EditFixture }                   from './partner/crud/editFixture';
export { default as AddTournamentTeamMember }       from './partner/crud/addTournamentTeamMember';
export { default as AddTournament }                 from './partner/crud/addTournament';
export { default as AddTeam }                       from './partner/crud/addTeam';
export { default as ViewTournament }                from './partner/crud/viewTournament';
export { default as AddTournamentTeam }             from './partner/crud/addTournamentTeam';
export { default as AddTournamentFixture }          from './partner/crud/addTournamentFixture';
export { default as HostGame }                      from './partner/crud/hostGame';
export { default as partnerNotification }           from './partner/partnerNotification';
export { default as DeleteFixture }                 from './partner/crud/deleteFixture';
export { default as DeleteTournament }              from './partner/crud/deleteTournament';
export { default as EditTournament }                from './partner/crud/editTournament';
export { default as EditTeam }                      from './partner/crud/editTeam';
export { default as EditMatch }                     from './partner/crud/editMatch';
export { default as EditTournamentSubscription }    from './partner/crud/editTournamentSubscription';

export { default as AddRental }                     from './partner/crud/addRental';
export { default as AddSubscription }               from './partner/crud/addSubscription';

export { default as RevenueBreakup }               from './centerportal/revenueBreakup';
export { default as CollectionDetails }               from './centerportal/collectionDetails';
export { default as CollectionList }               from './centerportal/collectionList';



// WEBPACK FOOTER //
// ./src/app/views/index.js